import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { r_burger } from '@fiverr-private/icons';

import { BODY_SIDEBAR_SHOWN_CLASS } from '../../constants';
import './style.scss';

/**
 * "Opens" the sidebar by adding the appropriate class to the <body> element.
 */
const openSidebar = () => {
    document.body.classList.add(BODY_SIDEBAR_SHOWN_CLASS);
};

/**
 * "Closes" the sidebar by removing the appropriate class to the <body> element.
 */
const closeSidebar = () => {
    document.body.classList.remove(BODY_SIDEBAR_SHOWN_CLASS);
};

const Navicon = () => {
    const locationHref = global.location && global.location.href;

    useEffect(() => {
        closeSidebar();
    }, [locationHref]);

    return (
        <button className="btn-navicon js-side-nav-trigger" onClick={() => openSidebar()}>
            <Icon size={26}>{r_burger}</Icon>
        </button>
    );
};

Navicon.contextTypes = {
    user: PropTypes.object,
};

export default Navicon;
